export const FULL_DAY_IN_MINUTES = 24 * 60;

// Same cap as the API (PlannerService.MaxFullDayBlockedDays).
export const MAX_FULL_DAY_BLOCKED_DAYS = 92;

export const startOfLocalDay = (date: Date): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

/** A blocked time saved in full-day mode: from 00:00, for exactly one day. */
export const isFullDayBlockedTime = (
  start: Date | undefined,
  durationInMinutes: number | undefined,
): boolean =>
  !!start &&
  durationInMinutes === FULL_DAY_IN_MINUTES &&
  start.getHours() === 0 &&
  start.getMinutes() === 0;
